import { useState, useEffect } from "react";
import { FaTrash, FaInfoCircle } from "react-icons/fa";
import { FaFileExcel } from "react-icons/fa6";

import { headersValid } from "../Layout/constants";

import * as XLSX from "sheetjs-style";

import Loader from "../Layout/loader";

import axios from "axios";
import { codigoEvento } from "../Utils/utils";
import DashboardProduto from "./dash";

export default function ModalProdutos({
  type,
  onSubmit,
  onClose,
  grupos,
  cores,
  produtos,
  itemsList,
  modalData,
  onAddItem,
  onImportar,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [onError, setOnError] = useState(false);
  const [message, setMessage] = useState("");
  const [onSuccess, setOnSuccess] = useState(false);
  const [dataImport, setDataImport] = useState({});

  const [modalType, setModalType] = useState("");
  const [codigo, setCodigo] = useState("");
  const [descricao, setDescricao] = useState("");
  const [unidade, setUnidade] = useState("");
  const [valor, setValor] = useState("");
  const [valorComissao, setValorComissao] = useState("");
  const [porcComissao, setPorcComissao] = useState("");
  const [grupo, setGrupo] = useState("");
  const [imagem, setImagem] = useState(itemsList[0].value);
  const [cor, setCor] = useState(cores[0].value);
  const [ativo, setAtivo] = useState(true);
  const [promo, setPromo] = useState(false);
  const [vendaPeso, setVendaPeso] = useState(false);
  const [ingresso, setIngresso] = useState(false);
  const [grupoIngresso, setGrupoIngresso] = useState("");
  const [gruposList, setGruposList] = useState(grupos);
  const [produtosList, setProdutosList] = useState([]);

  const [buscaGrupo, setBuscaGrupo] = useState("");
  const [buscaImagem, setBuscaImagem] = useState(itemsList[0].label);
  const [buscaCor, setBuscaCor] = useState(cores[0].label);
  const [abertoGrupo, setAbertoGrupo] = useState(false);
  const [abertoImagem, setAbertoImagem] = useState(false);
  const [abertoCor, setAbertoCor] = useState(false);

  const [buscaProduto, setBuscaProduto] = useState("");
  const [abertoProduto, setAbertoProduto] = useState(false);
  const [produto, setProduto] = useState({});
  const [qttProduto, setQttProduto] = useState("");
  const [promocaoList, setPromocaoList] = useState([]);

  useEffect(() => {
    setModalType(type);
    setProdutosList(produtos);

    if (modalData && Object.keys(modalData).length > 0) {
      setCodigo(modalData.CODIGO);

      setDescricao(modalData.DESCRICAO);
      setUnidade(modalData.UNIDADE);
      setValor(modalData.PRECOVENDA);
      setValorComissao(modalData.COMISSAOVALOR);
      setPorcComissao(modalData.COMISSAOPORC);
      setGrupo(modalData.CODGRUPO);

      const corSelecionada = cores.filter(
        (cor) => cor.value === convertAPIColor(modalData.COR)
      );

      const grupoSelecionado = grupos.filter(
        (grupo) => grupo.value === modalData.CODGRUPO
      );

      const imagemSelecionada = itemsList.filter(
        (imagem) => imagem.value === `/icone/${modalData.IMAGEM}`
      );

      if (corSelecionada) {
        setCor(corSelecionada[0].value);
        setBuscaCor(corSelecionada[0].label);
      }
      if (grupoSelecionado) {
        setGrupo(grupoSelecionado[0]?.value || "");
        setBuscaGrupo(grupoSelecionado[0]?.label || "");
      }
      if (imagemSelecionada) {
        setImagem(imagemSelecionada[0].value);
        setBuscaImagem(imagemSelecionada[0].label);
      }

      setAtivo(modalData.ATIVO === "S");
      setVendaPeso(modalData.VENDAPESO === "S");
      setIngresso(modalData.INGRESSO === "S");
      setGrupoIngresso(modalData.CODINGRESSO);
      setPromo(modalData.PROMO === "True");

      getItensCompostos();
    }
  }, []);

  function getItensCompostos() {
    if (modalData.CODIGO) {
      axios
        .get(`${process.env.REACT_APP_API_URL}/Composto`, {
          headers: { auth: process.env.REACT_APP_API_TOKEN },
          params: {
            codaluguel: codigoEvento(),
            codProdPrinc: modalData.CODIGO,
          },
        })
        .then((res) => {
          if (res.status === 200) {
            let promoList = [];
            res.data.forEach((item) => {
              promoList.push({
                CODIGO: item.CODPRODCOMP,
                DESCRICAO: item.DESCRICAO,
                QTD: item.QTDE,
                IMAGEM: item.IMAGEM,
                COR: item.COR,
              });
            });
            setPromocaoList(promoList);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }

  const gruposFiltrados = gruposList.filter((grupo) =>
    grupo.label.toLowerCase().includes(buscaGrupo.toLowerCase())
  );

  const imagensFiltradas = itemsList.filter((item) =>
    item.label.toLowerCase().includes(buscaImagem.toLowerCase())
  );

  const coresFiltradas = cores.filter((cor) =>
    cor.label.toLowerCase().includes(buscaCor.toLowerCase())
  );

  const produtosFiltrados = produtosList.filter(
    (produto) =>
      produto.DESCRICAO.toLowerCase().includes(buscaProduto.toLowerCase()) ||
      produto.CODIGO.toString().includes(buscaProduto.toLowerCase())
  );

  function closeModal() {
    setDescricao("");
    setUnidade("");
    setValor("");
    setValorComissao("");
    setPorcComissao("");
    setGrupo("");
    setImagem("");
    setCor("");
    setAtivo(true);
    setVendaPeso(false);
    setIngresso(false);
    setGrupoIngresso("");
    setBuscaGrupo("");
    setBuscaImagem("");
    setBuscaCor("");
    setPromo(false);

    setAbertoGrupo(false);
    setAbertoImagem(false);
    setAbertoCor(false);

    onClose();
  }

  function handleSubmit(e) {
    e.preventDefault();

    const data = {
      descricao,
      unidade,
      valor: Number(valor),
      valorComissao,
      porcComissao,
      grupo,
      imagem: imagem.replace("/icone/", ""),
      cor,
      ativo,
      vendaPeso,
      ingresso,
      grupoIngresso,
      type: modalType,
      codigo,
      promo,
    };

    onSubmit(data);
    closeModal();
  }

  function handleAddItem(e) {
    e.preventDefault();
    const data = {
      CODIGO: produto.CODIGO,
      QTD: Number(qttProduto),
      DESCRICAO: produto.DESCRICAO,
      IMAGEM: produto.IMAGEM,
      COR: produto.COR,
    };

    const postData = {
      codaluguel: codigoEvento(),
      codProdPrinc: codigo,
      codProdComp: produto.CODIGO,
      descricao: produto.DESCRICAO,
      qtde: qttProduto,
    };

    axios
      .post(`${process.env.REACT_APP_API_URL}/Composto`, postData, {
        headers: { auth: process.env.REACT_APP_API_TOKEN },
      })
      .then((res) => {
        onAddItem(data);
        setAbertoProduto(false);
        setPromocaoList([...promocaoList, data]);
        setProduto({});
        setBuscaProduto("");
        setQttProduto("");
        getItensCompostos();
      });
  }

  function handleRemoveItem(productCode, productName) {
    const confirm = window.confirm(
      `Tem certeza que deseja excluir o item: ${productCode} - ${productName}?`
    );
    if (!confirm) return;

    axios
      .delete(`${process.env.REACT_APP_API_URL}/Composto`, {
        headers: { auth: process.env.REACT_APP_API_TOKEN },
        params: {
          codaluguel: codigoEvento(),
          codProdPrinc: modalData.CODIGO,
          codProdComp: productCode,
        },
      })
      .then((res) => {
        getItensCompostos();
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }

  function convertAPIColor(argb) {
    const hex = argb.replace("$", "");
    const blue = hex.substring(2, 4);
    const green = hex.substring(4, 6);
    const red = hex.substring(6, 8);
    return `#${red}${green}${blue}`;
  }

  function changeModalType(type) {
    setDescricao("");
    setUnidade("");
    setValor("");
    setValorComissao("");
    setPorcComissao("");
    setGrupo("");
    setImagem(itemsList[0].value);
    setCor(cores[0].value);
    setAtivo(true);
    setVendaPeso(false);
    setIngresso(false);
    setGrupoIngresso("");
    setBuscaGrupo("");
    setBuscaImagem(itemsList[0].label);
    setBuscaCor(cores[0].label);
    setPromo(false);

    setAbertoGrupo(false);
    setAbertoImagem(false);
    setAbertoCor(false);
    setModalType(type);
  }

  function handleImport(e) {
    const file = e.target.files[0];
    if (!file) return;

    setIsLoading(true);
    setMessage("");

    const confirm = window.confirm(
      "Tem certeza que deseja importar o arquivo?"
    );
    if (!confirm) return;

    try {
      // Verificar o tipo do arquivo
      if (
        !file ||
        ![
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          "application/vnd.ms-excel",
          ".xlsx",
          ".xls",
        ].includes(file.type)
      ) {
        setIsLoading(false);
        setDataImport({});
        setOnSuccess(false);
        setMessage("O arquivo selecionado não é uma planilha Excel válida.");
        setOnError(true);
        return;
      }

      const reader = new FileReader();

      reader.onload = (e) => {
        try {
          // Lê os dados binários do arquivo
          const data = new Uint8Array(e.target.result);

          // Converte para o formato do workbook
          const workbook = XLSX.read(data, { type: "array" });

          // Pega o nome da primeira planilha
          const firstSheetName = workbook.SheetNames[0];

          // Lê a planilha
          const worksheet = workbook.Sheets[firstSheetName];

          // Converte para um array de objetos
          const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

          // Se quiser os dados com cabeçalhos como propriedades de objetos:
          // Assumindo que a primeira linha contém os cabeçalhos
          const headers = jsonData[0];
          const rows = jsonData.slice(1);

          const hasError = headers.some(
            (header) => !headersValid.includes(header)
          );

          if (hasError) {
            setOnError(true);
            setMessage(
              "O arquivo selecionado não é uma planilha Excel válida. Utilize o modelo fornecido."
            );
            setIsLoading(false);
            setDataImport({});
            setOnSuccess(false);
            return;
          }

          let formattedData = rows.map((row) => {
            const rowData = {};
            headers.forEach((header, index) => {
              rowData[header] = row[index];
            });
            return rowData;
          });

          formattedData = formattedData.map((item) => {
            if (
              item.descricao === "Obrigatório" &&
              item.vlrUni === "Obrigatório"
            ) {
              return null;
            }
            return item;
          });
          formattedData = formattedData.filter((item) => item !== null);

          const hasProcuctsInvalid = formattedData.some(
            (item) => !item.descricao || !item.vlrUni
          );

          if (hasProcuctsInvalid) {
            const confirm2 = window.confirm(
              "Existem produtos com informações faltantes na planilha. Deseja continuar a inserção dos outros produtos válidos?"
            );

            if (!confirm2) {
              setOnError(true);
              setMessage(
                "Existem produtos faltando campos obrigatórios. Verifique o arquivo e tente novamente."
              );
              setIsLoading(false);
              setDataImport({});
              setOnSuccess(false);
              return;
            } else {
              formattedData = formattedData.filter(
                (item) => item.descricao && item.vlrUni
              );
            }
          }

          // Chama o callback de sucesso com os dados processados
          setOnSuccess(true);
          setMessage("Planilha processada com sucesso.");
          setDataImport({
            raw: jsonData, // Dados brutos em formato de matriz
            formatted: formattedData, // Dados com cabeçalhos como propriedades
            headers: headers, // Apenas os cabeçalhos
          });
          setIsLoading(false);
          setOnError(false);

          onImportar(formattedData);
        } catch (error) {
          console.error("Erro ao processar a planilha:", error);
          setOnError(true);
          setOnSuccess(false);
          setIsLoading(false);
          setDataImport({});
          setMessage("Erro ao processar a planilha. " + error.message);
        }
      };

      reader.onerror = (error) => {
        console.error("Erro na leitura do arquivo:", error);
        setOnError(true);
        setOnSuccess(false);
        setIsLoading(false);
        setDataImport({});
        setMessage("Erro na leitura do arquivo.");
      };

      // Lê o arquivo como um ArrayBuffer
      reader.readAsArrayBuffer(file);
    } catch (error) {
      console.error("Erro ao iniciar importação:", error);
      setOnError(true);
      setOnSuccess(false);
      setIsLoading(false);
      setDataImport({});
      setMessage("Erro ao iniciar importação da planilha.");
    }
  }

  return (
    <>
      <div className="fixed inset-0 z-10 flex items-center justify-center">
        <div
          onClick={() => {
            closeModal();
          }}
          className="absolute h-screen inset-0 bg-black/60 backdrop-blur-sm"
        ></div>
        <div className="relative z-20 bg-white rounded-lg w-[95%] lg:w-[95%] max-h-[80vh] overflow-hidden flex flex-col">
          <div className="overflow-y-auto p-4 flex-1">
            {modalType === "create" ? (
              <div className="flex flex-col box-border p-4 gap-2 w-full">
                <h1 className="font-Oswald text-center">Adicionar Produto</h1>

                <div className="flex overflow-hidden justify-center items-center flex-col box-border p-4 gap-2 w-full">
                  <div
                    style={{
                      backgroundColor: cor,
                    }}
                    className={`flex max-w-[90%] items-center gap-4 p-2 rounded-lg text-white `}
                  >
                    <img width={"70px"} src={`${imagem}`} alt="Grupo" />
                    <div className="flex flex-col gap-2">
                      <span className="text-center text-lg font-[600]">
                        {Number(valor).toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        })}
                      </span>
                      <span className="text-center">{descricao}</span>
                    </div>
                  </div>
                </div>

                <form
                  onSubmit={(e) => handleSubmit(e)}
                  autoComplete="off"
                  className="flex flex-col flex-wrap gap-2 w-full"
                >
                  <div className="grid col-span-2 grid-cols-1 md:grid-cols-2 gap-4 w-full">
                    <div className="flex flex-col gap-2 text-base font-[500] w-full">
                      <label htmlFor="descricao">Descrição</label>
                      <input
                        name="descricao"
                        type="text"
                        onChange={(e) => setDescricao(e.target.value)}
                        className="font-Roboto  text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        value={descricao}
                        placeholder="Descrição"
                        required
                      />
                    </div>
                    <div className="flex flex-col gap-2 text-base font-[500] w-full">
                      <label htmlFor="unidade">Unidade</label>
                      <input
                        name="unidade"
                        type="text"
                        onChange={(e) => setUnidade(e.target.value)}
                        className="font-Roboto  text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        value={unidade}
                        placeholder="Unidade"
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full">
                    <div className="flex flex-col gap-2 text-base font-[500] w-full">
                      <label htmlFor="valor">Valor</label>
                      <input
                        name="valor"
                        type="number"
                        min="0"
                        step="0.01"
                        onChange={(e) => setValor(e.target.value)}
                        className="font-Roboto  text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        value={valor}
                        placeholder="Valor"
                        onWheel={(e) => e.target.blur()}
                        required
                      />
                    </div>

                    <div className="flex flex-col gap-2 text-base font-[500] w-full">
                      <label htmlFor="valorComissao">Valor de Comissão</label>
                      <input
                        name="valorComissao"
                        type="number"
                        min="0"
                        step="0.01"
                        onChange={(e) => setValorComissao(e.target.value)}
                        className="font-Roboto  text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        value={valorComissao}
                        placeholder="Valor de Comissão"
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>

                    <div className="flex flex-col gap-2 text-base font-[500] w-full">
                      <label htmlFor="porcComissao">% da Comissão</label>
                      <input
                        name="porcComissao"
                        type="number"
                        min="0"
                        step="0.001"
                        onChange={(e) => setPorcComissao(e.target.value)}
                        className="font-Roboto  text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        value={porcComissao}
                        placeholder="% da Comissão"
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full">
                    <div className="flex flex-col gap-2 text-base font-[500] w-full">
                      <label
                        className="font-Roboto text-base font-[500] "
                        htmlFor="grupo"
                      >
                        Grupo
                      </label>
                      <div className="font-Roboto font-[500] relative w-full">
                        <input
                          autoComplete="off"
                          type="text"
                          name="grupo"
                          className="font-Roboto w-fill-available text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                          placeholder="Selecione uma opção"
                          value={buscaGrupo}
                          onChange={(e) => {
                            setBuscaGrupo(e.target.value);
                            // setAbertoGrupo(!abertoGrupo);
                          }}
                          onFocus={() => {
                            setAbertoGrupo(!abertoGrupo);
                            setBuscaGrupo("");
                          }}
                        />

                        {abertoGrupo && (
                          <ul className="font-Roboto flex flex-col  text-base font-[500] absolute z-10 w-full overflow-x-hidden bg-white border border-gray-300 rounded-md max-h-60 overflow-y-auto shadow-md">
                            {gruposFiltrados.length > 0 ? (
                              gruposFiltrados.map((option) => (
                                <li
                                  style={{
                                    backgroundColor: option.color,
                                  }}
                                  key={option.value}
                                  className="px-4 py-2 cursor-pointer hover:bg-blue-100"
                                  onClick={() => {
                                    //console.log(option);
                                    setGrupo(option.value);
                                    setImagem(option.image);
                                    setCor(option.color);
                                    setBuscaCor(option.corLabel);
                                    setBuscaGrupo(option.label);
                                    setBuscaImagem(option.imagemLabel);
                                    setAbertoGrupo(false);
                                  }}
                                >
                                  <div className="flex box-border items-center gap-4">
                                    <img
                                      src={`${option.image}`}
                                      alt="Grupo"
                                      width={"50px"}
                                    />
                                    <span className="text-wrap break-words">
                                      {option.label}
                                    </span>
                                  </div>
                                </li>
                              ))
                            ) : (
                              <li className="font-Roboto px-4 py-2 text-gray-500">
                                Nenhuma opção encontrada
                              </li>
                            )}
                          </ul>
                        )}
                      </div>
                    </div>

                    <div className="flex flex-col gap-2 text-base font-[500] w-full">
                      <label
                        className="font-Roboto text-base font-[500] "
                        htmlFor="imagem"
                      >
                        Imagem
                      </label>
                      <div className="font-Roboto font-[500] relative w-full">
                        <input
                          autoComplete="off"
                          type="text"
                          name="imagem"
                          className="font-Roboto w-fill-available text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                          placeholder="Selecione uma opção"
                          value={buscaImagem}
                          onChange={(e) => {
                            setBuscaImagem(e.target.value);
                            // setAbertoImagem(!abertoImagem);
                          }}
                          onFocus={() => {
                            setBuscaImagem("");
                            setAbertoImagem(!abertoImagem);
                          }}
                        />

                        {abertoImagem && (
                          <ul className="font-Roboto flex flex-col  text-base font-[500] absolute z-10 w-full overflow-x-hidden bg-white border border-gray-300 rounded-md max-h-60 overflow-y-auto shadow-md">
                            {imagensFiltradas.length > 0 ? (
                              imagensFiltradas.map((option) => (
                                <li
                                  key={option.value}
                                  className="px-4 py-2 cursor-pointer hover:bg-blue-100"
                                  onClick={() => {
                                    setImagem(option.value);
                                    setBuscaImagem(option.label);
                                    setAbertoImagem(false);
                                  }}
                                >
                                  <div className="flex box-border items-center gap-4">
                                    <img
                                      src={`${option.value}`}
                                      alt="Grupo"
                                      width={"50px"}
                                    />
                                    <span className="text-wrap break-words">
                                      {option.label}
                                    </span>
                                  </div>
                                </li>
                              ))
                            ) : (
                              <li className="font-Roboto px-4 py-2 text-gray-500">
                                Nenhuma opção encontrada
                              </li>
                            )}
                          </ul>
                        )}
                      </div>
                    </div>

                    <div className="flex flex-col gap-2 text-base font-[500] w-full">
                      <label
                        className="font-Roboto text-base font-[500] "
                        htmlFor="cor"
                      >
                        Cor
                      </label>
                      <div className="font-Roboto font-[500] relative w-full">
                        <input
                          autoComplete="off"
                          type="text"
                          style={{ backgroundColor: cor }}
                          name="cor"
                          className="font-Roboto w-fill-available text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                          placeholder="Selecione uma opção"
                          value={buscaCor}
                          onChange={(e) => {
                            setBuscaCor(e.target.value);
                            // setAbertoCor(!abertoCor);
                          }}
                          onFocus={() => {
                            setBuscaCor("");
                            setAbertoCor(!abertoCor);
                          }}
                        />

                        {abertoCor && (
                          <ul className="font-Roboto flex flex-col  text-base font-[500] absolute z-10 w-full overflow-x-hidden bg-white border border-gray-300 rounded-md max-h-60 overflow-y-auto shadow-md">
                            {coresFiltradas.length > 0 ? (
                              coresFiltradas.map((option) => (
                                <li
                                  style={{
                                    backgroundColor: option.value,
                                  }}
                                  key={option.value}
                                  className="px-4 py-2 cursor-pointer hover:bg-blue-100"
                                  onClick={() => {
                                    setCor(option.value);
                                    setBuscaCor(option.label);
                                    setAbertoCor(false);
                                  }}
                                >
                                  <div className="flex box-border items-center gap-4">
                                    <span className="text-wrap break-words">
                                      {option.label}
                                    </span>
                                  </div>
                                </li>
                              ))
                            ) : (
                              <li className="font-Roboto px-4 py-2 text-gray-500">
                                Nenhuma opção encontrada
                              </li>
                            )}
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full">
                    <div className="flex flex-row gap-2 items-center text-base font-[500] w-full">
                      <button
                        type="button"
                        onClick={() => setAtivo(!ativo)}
                        className={`cursor-pointer w-14 h-8 flex items-center p-1 rounded-full transition-colors duration-300 ease-in-out border-none  ${
                          ativo ? "bg-blue-500" : "bg-gray-300"
                        }`}
                      >
                        <span
                          className={`w-6 h-6 bg-white rounded-full shadow-md  transition-transform duration-300 ease-in-out  ${
                            ativo ? "translate-x-6" : "translate-x-0"
                          }`}
                        ></span>
                      </button>
                      <span className="text-sm">
                        {ativo ? "Ativo" : "Desativado"}
                      </span>
                    </div>

                    <div className="flex flex-row gap-2 items-center text-base font-[500] w-full">
                      <button
                        type="button"
                        onClick={() => setVendaPeso(!vendaPeso)}
                        className={`cursor-pointer w-14 h-8 flex items-center p-1 rounded-full  transition-colors duration-300 ease-in-out border-none   ${
                          vendaPeso ? "bg-blue-500" : "bg-gray-300"
                        }`}
                      >
                        <span
                          className={`w-6 h-6 bg-white rounded-full shadow-md   transition-transform duration-300 ease-in-out  ${
                            vendaPeso ? "translate-x-6" : "translate-x-0"
                          }`}
                        ></span>
                      </button>
                      <span className="text-sm">Venda por peso</span>
                    </div>

                    <div className="flex flex-row gap-2 items-center text-base font-[500] w-full">
                      <button
                        type="button"
                        onClick={() => setPromo(!promo)}
                        className={`cursor-pointer w-14 h-8 flex items-center p-1 rounded-full   transition-colors duration-300 ease-in-out border-none  ${
                          promo ? "bg-blue-500" : "bg-gray-300"
                        }`}
                      >
                        <span
                          className={`w-6 h-6 bg-white rounded-full shadow-md   transition-transform duration-300 ease-in-out  ${
                            promo ? "translate-x-6" : "translate-x-0"
                          }`}
                        ></span>
                      </button>
                      <span className="text-sm">Promoção</span>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full">
                    <div className="flex flex-row gap-2 items-center text-base font-[500] w-full">
                      <button
                        type="button"
                        onClick={() => setIngresso(!ingresso)}
                        className={`cursor-pointer w-14 h-8 flex items-center p-1 rounded-full 
                              transition-colors duration-300 ease-in-out border-none
                              ${ingresso ? "bg-blue-500" : "bg-gray-300"}`}
                      >
                        <span
                          className={`w-6 h-6 bg-white rounded-full shadow-md 
                              transition-transform duration-300 ease-in-out
                              ${ingresso ? "translate-x-6" : "translate-x-0"}`}
                        ></span>
                      </button>
                      <span className="text-sm">Ingresso</span>
                    </div>
                  </div>
                  {ingresso && (
                    <div className="flex flex-col gap-2 text-base font-[500] ">
                      <label htmlFor="grupoIngresso">Grupo de Ingressos</label>
                      <input
                        name="grupoIngresso"
                        type="number"
                        min="0"
                        onChange={(e) => setGrupoIngresso(e.target.value)}
                        className="font-Roboto w-[250px] lg:w-[350px] text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        value={grupoIngresso ?? 0}
                        placeholder="Tipo do ingresso informado pela Santa Cartão"
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                  )}

                  <div className="flex gap-2 justify-end w-full">
                    <button
                      type="button"
                      onClick={() => {
                        closeModal();
                      }}
                      className="flex gap-2 font-[500] items-center rounded-lg text-lg border-none p-2 bg-[#e74c3c]  text-white transition cursor-pointer hover:bg-[#c0392b] font-Roboto"
                    >
                      Cancelar
                    </button>
                    <button
                      type="submit"
                      className="flex gap-2 font-[500] items-center rounded-lg text-lg border-none p-2 bg-[#2185D0] text-white transition cursor-pointer hover:bg-[#1A6DA8] font-Roboto"
                    >
                      Salvar
                    </button>
                  </div>
                </form>
              </div>
            ) : modalType === "edit" ? (
              <div className="flex flex-col box-border p-4 gap-2 w-full">
                <h1 className="font-Oswald text-center">Editar Produto</h1>

                <div className="flex overflow-hidden justify-center items-center flex-col box-border p-4 gap-2 w-full">
                  <div
                    style={{
                      backgroundColor: cor,
                    }}
                    className={`flex max-w-[90%] items-center gap-4 p-2 rounded-lg text-white `}
                  >
                    <img width={"70px"} src={`${imagem}`} alt="Grupo" />
                    <div className="flex flex-col gap-2">
                      <span className="text-center text-lg font-[600]">
                        {Number(valor).toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        })}
                      </span>
                      <span className="text-center">{descricao}</span>
                    </div>
                  </div>
                </div>

                <form
                  onSubmit={(e) => handleSubmit(e)}
                  autoComplete="off"
                  className="flex flex-col flex-wrap gap-2 w-full"
                >
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full">
                    <div className="flex flex-col gap-2 text-base font-[500] w-full">
                      <label htmlFor="codigo">Código</label>
                      <input
                        name="codigo"
                        type="text"
                        className="font-Roboto  text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        value={codigo}
                        placeholder="Código"
                        disabled
                      />
                    </div>
                    <div className="flex flex-col gap-2 text-base font-[500] w-full">
                      <label htmlFor="descricao">Descrição</label>
                      <input
                        name="descricao"
                        type="text"
                        onChange={(e) => setDescricao(e.target.value)}
                        className="font-Roboto text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        value={descricao}
                        placeholder="Descrição"
                        required
                      />
                    </div>
                    <div className="flex flex-col gap-2 text-base font-[500] w-full">
                      <label htmlFor="unidade">Unidade</label>
                      <input
                        name="unidade"
                        type="text"
                        onChange={(e) => setUnidade(e.target.value)}
                        className="font-Roboto  text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        value={unidade}
                        placeholder="Unidade"
                      />
                    </div>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full">
                    <div className="flex flex-col gap-2 text-base font-[500] w-full">
                      <label htmlFor="valor">Valor</label>
                      <input
                        name="valor"
                        type="number"
                        step="0.01"
                        min="0"
                        onChange={(e) => setValor(e.target.value)}
                        className="font-Roboto  text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        value={valor}
                        placeholder="Valor"
                        required
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>

                    <div className="flex flex-col gap-2 text-base font-[500] w-full">
                      <label htmlFor="valorComissao">Valor de Comissão</label>
                      <input
                        name="valorComissao"
                        type="number"
                        step="0.01"
                        min="0"
                        onChange={(e) => setValorComissao(e.target.value)}
                        className="font-Roboto text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        value={valorComissao}
                        placeholder="Valor de Comissão"
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>

                    <div className="flex flex-col gap-2 text-base font-[500] w-full">
                      <label htmlFor="porcComissao">% da Comissão</label>
                      <input
                        name="porcComissao"
                        type="number"
                        step="0.001"
                        min="0"
                        onChange={(e) => setPorcComissao(e.target.value)}
                        className="font-Roboto text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        value={porcComissao}
                        placeholder="% da Comissão"
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full">
                    <div className="flex flex-col gap-2 text-base font-[500] w-full">
                      <label
                        className="font-Roboto text-base font-[500] "
                        htmlFor="grupo"
                      >
                        Grupo
                      </label>
                      <div className="font-Roboto font-[500] relative w-full">
                        <input
                          autoComplete="off"
                          type="text"
                          name="grupo"
                          className="font-Roboto text-base w-fill-available font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                          placeholder="Selecione uma opção"
                          value={buscaGrupo}
                          onChange={(e) => {
                            setBuscaGrupo(e.target.value);
                            // setAbertoGrupo(!abertoGrupo);
                          }}
                          onFocus={() => {
                            setAbertoGrupo(!abertoGrupo);
                            setBuscaGrupo("");
                          }}
                        />

                        {abertoGrupo && (
                          <ul className="font-Roboto flex flex-col  text-base font-[500] absolute z-10 w-full overflow-x-hidden bg-white border border-gray-300 rounded-md max-h-60 overflow-y-auto shadow-md">
                            {gruposFiltrados.length > 0 ? (
                              gruposFiltrados.map((option) => (
                                <li
                                  style={{
                                    backgroundColor: option.color,
                                  }}
                                  key={option.value}
                                  className="px-4 py-2 cursor-pointer hover:bg-blue-100"
                                  onClick={() => {
                                    //console.log(option);
                                    setGrupo(option.value);
                                    setImagem(option.image);
                                    setCor(option.color);
                                    setBuscaCor(option.corLabel);
                                    setBuscaGrupo(option.label);
                                    setBuscaImagem(option.imagemLabel);
                                    setAbertoGrupo(false);
                                  }}
                                >
                                  <div className="flex box-border items-center gap-4">
                                    <img
                                      src={`${option.image}`}
                                      alt="Grupo"
                                      width={"50px"}
                                    />
                                    <span className="text-wrap break-words">
                                      {option.label}
                                    </span>
                                  </div>
                                </li>
                              ))
                            ) : (
                              <li className="font-Roboto px-4 py-2 text-gray-500">
                                Nenhuma opção encontrada
                              </li>
                            )}
                          </ul>
                        )}
                      </div>
                    </div>

                    <div className="flex flex-col gap-2 text-base font-[500] w-full">
                      <label
                        className="font-Roboto text-base font-[500] "
                        htmlFor="imagem"
                      >
                        Imagem
                      </label>
                      <div className="font-Roboto font-[500] relative w-full">
                        <input
                          autoComplete="off"
                          type="text"
                          name="imagem"
                          className="font-Roboto w-fill-available text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                          placeholder="Selecione uma opção"
                          value={buscaImagem}
                          onChange={(e) => {
                            setBuscaImagem(e.target.value);
                            // setAbertoImagem(!abertoImagem);
                          }}
                          onFocus={() => {
                            setBuscaImagem("");
                            setAbertoImagem(!abertoImagem);
                          }}
                        />

                        {abertoImagem && (
                          <ul className="font-Roboto flex flex-col  text-base font-[500] absolute z-10 w-full overflow-x-hidden bg-white border border-gray-300 rounded-md max-h-60 overflow-y-auto shadow-md">
                            {imagensFiltradas.length > 0 ? (
                              imagensFiltradas.map((option) => (
                                <li
                                  key={option.value}
                                  className="px-4 py-2 cursor-pointer hover:bg-blue-100"
                                  onClick={() => {
                                    setImagem(option.value);
                                    setBuscaImagem(option.label);
                                    setAbertoImagem(false);
                                  }}
                                >
                                  <div className="flex box-border items-center gap-4">
                                    <img
                                      src={`${option.value}`}
                                      alt="Grupo"
                                      width={"50px"}
                                    />
                                    <span className="text-wrap break-words">
                                      {option.label}
                                    </span>
                                  </div>
                                </li>
                              ))
                            ) : (
                              <li className="font-Roboto px-4 py-2 text-gray-500">
                                Nenhuma opção encontrada
                              </li>
                            )}
                          </ul>
                        )}
                      </div>
                    </div>

                    <div className="flex flex-col gap-2 text-base font-[500] w-full">
                      <label
                        className="font-Roboto text-base font-[500] "
                        htmlFor="cor"
                      >
                        Cor
                      </label>
                      <div className="font-Roboto font-[500] relative w-full">
                        <input
                          autoComplete="off"
                          style={{ backgroundColor: cor }}
                          type="text"
                          name="cor"
                          className="font-Roboto w-fill-available text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                          placeholder="Selecione uma opção"
                          value={buscaCor}
                          onChange={(e) => {
                            setBuscaCor(e.target.value);
                            // setAbertoCor(!abertoCor);
                          }}
                          onFocus={() => {
                            setBuscaCor("");
                            setAbertoCor(!abertoCor);
                          }}
                        />

                        {abertoCor && (
                          <ul className="font-Roboto flex flex-col  text-base font-[500] absolute z-10 w-full overflow-x-hidden bg-white border border-gray-300 rounded-md max-h-60 overflow-y-auto shadow-md">
                            {coresFiltradas.length > 0 ? (
                              coresFiltradas.map((option) => (
                                <li
                                  style={{
                                    backgroundColor: option.value,
                                  }}
                                  key={option.value}
                                  className="px-4 py-2 cursor-pointer hover:bg-blue-100"
                                  onClick={() => {
                                    setCor(option.value);
                                    setBuscaCor(option.label);
                                    setAbertoCor(false);
                                  }}
                                >
                                  <div className="flex box-border items-center gap-4">
                                    <span className="text-wrap break-words">
                                      {option.label}
                                    </span>
                                  </div>
                                </li>
                              ))
                            ) : (
                              <li className="font-Roboto px-4 py-2 text-gray-500">
                                Nenhuma opção encontrada
                              </li>
                            )}
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full">
                    <div className="flex flex-row gap-2 items-center text-base font-[500] w-full">
                      <button
                        type="button"
                        onClick={() => setAtivo(!ativo)}
                        className={`cursor-pointer w-14 h-8 flex items-center p-1 rounded-full transition-colors duration-300 ease-in-out border-none  ${
                          ativo ? "bg-blue-500" : "bg-gray-300"
                        }`}
                      >
                        <span
                          className={`w-6 h-6 bg-white rounded-full shadow-md  transition-transform duration-300 ease-in-out  ${
                            ativo ? "translate-x-6" : "translate-x-0"
                          }`}
                        ></span>
                      </button>
                      <span className="text-sm">
                        {ativo ? "Ativo" : "Desativado"}
                      </span>
                    </div>

                    <div className="flex flex-row gap-2 items-center text-base font-[500] w-full">
                      <button
                        type="button"
                        onClick={() => setVendaPeso(!vendaPeso)}
                        className={`cursor-pointer w-14 h-8 flex items-center p-1 rounded-full  transition-colors duration-300 ease-in-out border-none   ${
                          vendaPeso ? "bg-blue-500" : "bg-gray-300"
                        }`}
                      >
                        <span
                          className={`w-6 h-6 bg-white rounded-full shadow-md   transition-transform duration-300 ease-in-out  ${
                            vendaPeso ? "translate-x-6" : "translate-x-0"
                          }`}
                        ></span>
                      </button>
                      <span className="text-sm">Venda por peso</span>
                    </div>

                    <div className="flex flex-row gap-2 items-center text-base font-[500] w-full">
                      <button
                        type="button"
                        onClick={() => setPromo(!promo)}
                        className={`cursor-pointer w-14 h-8 flex items-center p-1 rounded-full   transition-colors duration-300 ease-in-out border-none  ${
                          promo ? "bg-blue-500" : "bg-gray-300"
                        }`}
                      >
                        <span
                          className={`w-6 h-6 bg-white rounded-full shadow-md   transition-transform duration-300 ease-in-out  ${
                            promo ? "translate-x-6" : "translate-x-0"
                          }`}
                        ></span>
                      </button>
                      <span className="text-sm">Promoção</span>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full">
                    <div className="flex flex-row gap-2 items-center text-base font-[500] w-full">
                      <button
                        type="button"
                        onClick={() => setIngresso(!ingresso)}
                        className={`cursor-pointer w-14 h-8 flex items-center p-1 rounded-full 
                              transition-colors duration-300 ease-in-out border-none
                              ${ingresso ? "bg-blue-500" : "bg-gray-300"}`}
                      >
                        <span
                          className={`w-6 h-6 bg-white rounded-full shadow-md 
                              transition-transform duration-300 ease-in-out
                              ${ingresso ? "translate-x-6" : "translate-x-0"}`}
                        ></span>
                      </button>
                      <span className="text-sm">Ingresso</span>
                    </div>
                  </div>
                  {ingresso && (
                    <div className="flex flex-col gap-2 text-base font-[500] ">
                      <label htmlFor="grupoIngresso">Grupo de Ingressos</label>
                      <input
                        name="grupoIngresso"
                        type="number"
                        min="0"
                        onChange={(e) => setGrupoIngresso(e.target.value)}
                        className="font-Roboto w-[250px] lg:w-[350px] text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        value={grupoIngresso ?? 0}
                        placeholder="Tipo do ingresso informado pela Santa Cartão"
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                  )}

                  <div className="flex gap-2 justify-end w-full">
                    <button
                      type="button"
                      onClick={() => {
                        closeModal();
                      }}
                      className="flex gap-2 font-[500] items-center rounded-lg text-lg border-none p-2 bg-[#e74c3c]  text-white transition cursor-pointer hover:bg-[#c0392b] font-Roboto"
                    >
                      Cancelar
                    </button>
                    <button
                      type="submit"
                      className="flex gap-2 font-[500] items-center rounded-lg text-lg border-none p-2 bg-[#2185D0] text-white transition cursor-pointer hover:bg-[#1A6DA8] font-Roboto"
                    >
                      Salvar
                    </button>
                  </div>
                </form>
                {promo && (
                  <div className="flex justify-center items-center flex-col gap-2">
                    <div className="flex flex-col justify-center items-center gap-2 w-full">
                      <h2 className="font-Oswald">Composição dos Produtos</h2>
                      <hr className="w-[100%] h-[2px] border-none bg-[#ccc] m-auto text-[#ccc]" />
                      <p className="text-sm text-center">
                        Para cada produto vendido será impresso a quantidade
                        especificada de fichas na tabela abaixo. Desabilite a
                        promoção para a ficha sair com descrição do cadastro.{" "}
                      </p>
                    </div>

                    <form
                      onSubmit={handleAddItem}
                      className="flex flex-wrap gap-2 justify-center items-center lg:items-end"
                    >
                      <div className="font-Roboto flex flex-col gap-2">
                        <label
                          className="font-Roboto text-base font-[500] "
                          htmlFor="produto"
                        >
                          Produto
                        </label>
                        <div className="font-Roboto font-[500] relative">
                          <input
                            autoComplete="off"
                            style={{
                              backgroundColor: produto?.COR
                                ? convertAPIColor(produto.COR)
                                : "",
                            }}
                            type="text"
                            name="produto"
                            className="font-Roboto w-[250px] text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            placeholder="Selecione uma opção"
                            value={buscaProduto}
                            onChange={(e) => {
                              setBuscaProduto(e.target.value);
                              // setAbertoProduto(!abertoProduto);
                            }}
                            onFocus={() => setAbertoProduto(!abertoProduto)}
                            required
                          />

                          {abertoProduto && (
                            <ul className="font-Roboto flex flex-col text-base font-[500] absolute z-10 w-full overflow-x-hidden bg-white border border-gray-300 rounded-md max-h-60 overflow-y-auto shadow-md">
                              {produtosFiltrados.length > 0 ? (
                                produtosFiltrados.map((option) => (
                                  <li
                                    key={option.CODIGO}
                                    style={{
                                      backgroundColor: convertAPIColor(
                                        option.COR
                                      ),
                                    }}
                                    className="px-4 py-2 cursor-pointer hover:bg-blue-100"
                                    onClick={() => {
                                      setProduto(option);
                                      setBuscaProduto(option.DESCRICAO);
                                      setAbertoProduto(false);
                                    }}
                                  >
                                    <div className="flex box-border items-center gap-4">
                                      <img
                                        src={`/icone/${option.IMAGEM}`}
                                        alt="Produto"
                                        width={"50px"}
                                      />
                                      <span className="text-wrap break-words">
                                        {option.DESCRICAO}
                                      </span>
                                    </div>
                                  </li>
                                ))
                              ) : (
                                <li className="font-Roboto px-4 py-2 text-gray-500">
                                  Nenhuma opção encontrada
                                </li>
                              )}
                            </ul>
                          )}
                        </div>
                      </div>
                      <div className="flex flex-col gap-2 text-base font-[500] ">
                        <label htmlFor="qttProduto">Quantidade</label>
                        <input
                          autoComplete="off"
                          name="qttProduto"
                          type="number"
                          min="0"
                          onChange={(e) => setQttProduto(e.target.value)}
                          className="font-Roboto w-[250px] text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                          value={qttProduto}
                          placeholder="Quantidade"
                          required
                          onWheel={(e) => e.target.blur()}
                        />
                      </div>

                      <button
                        type="submit"
                        className="flex gap-2 font-[500] items-center rounded-lg text-lg border-none p-2 bg-[#2185D0] text-white transition cursor-pointer hover:bg-[#1A6DA8] font-Roboto"
                      >
                        Adicionar Item
                      </button>
                      <button
                        onClick={() => changeModalType("create")}
                        type="button"
                        className="flex gap-2 font-[500] items-center rounded-lg text-lg border-none p-2 bg-[#2185D0] text-white transition cursor-pointer hover:bg-[#1A6DA8] font-Roboto"
                      >
                        Novo Produto
                      </button>
                    </form>

                    <div className="flex flex-col gap-2 w-full mt-4">
                      {promocaoList.map((item) => (
                        <div
                          style={{ backgroundColor: convertAPIColor(item.COR) }}
                          className="flex gap-2 p-2 justify-between items-center rounded-lg w-full"
                          key={item.CODIGO + "promo"}
                        >
                          <div className="flex gap-4 items-center w-[50%]">
                            <img
                              src={`/icone/${item.IMAGEM}`}
                              alt="Produto"
                              width={"50px"}
                            />
                            <span>
                              {item.CODIGO} - {item.DESCRICAO}
                            </span>
                          </div>
                          <span className="text-base">
                            {Number(item.QTD).toLocaleString("pt-BR", {
                              style: "decimal",
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 2,
                            })}
                          </span>
                          <button
                            onClick={() =>
                              handleRemoveItem(item.CODIGO, item.DESCRICAO)
                            }
                            className="bg-white cursor-pointer border border-solid border-gray-400 rounded-md p-2 hover:bg-red-500 hover:text-white transition"
                          >
                            <FaTrash size={20} />
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ) : modalType === "import" ? (
              isLoading ? (
                <Loader />
              ) : (
                <div className="flex flex-col gap-4">
                  <div className="flex flex-col gap-2">
                    <h1>Importar produtos</h1>
                    <hr className="w-[100%] h-[2px] border-none bg-[#ccc] m-auto text-[#ccc]" />
                  </div>
                  <div className="flex flex-col gap-2">
                    <label
                      className="flex w-fit p-4 text-base text-white items-center rounded-lg bg-[#2185D0] gap-2 transition cursor-pointer hover:bg-[#1A6DA8] font-Roboto"
                      htmlFor="file"
                    >
                      <FaFileExcel size={20} />
                      <span>Selecione a tabela</span>
                    </label>
                    <input
                      onChange={(e) => handleImport(e)}
                      className="hidden"
                      type="file"
                      id="file"
                      accept=".xlsx, .xls"
                    />

                    {onError || onSuccess ? (
                      <div className="flex justify-center items-center flex-col gap-2 w-full">
                        <div
                          className={`flex w-fit p-2 border border-solid border-red-500 rounded-lg bg-red-50 justify-center items-center flex-col gap-2 ${
                            onSuccess ? "border-green-500 bg-green-50" : ""
                          }`}
                        >
                          <FaInfoCircle
                            color={onSuccess ? "green" : "red"}
                            size={32}
                          />
                          <span>{message}</span>
                        </div>
                      </div>
                    ) : null}

                    <div>
                      <span>
                        Para baixar um modelo do arquivo de importação,{" "}
                      </span>
                      <a
                        className="text-blue-500"
                        href="/modeloSF.xls"
                        download
                      >
                        clique aqui
                      </a>
                    </div>
                  </div>

                  {Object.keys(dataImport).length > 0 ? (
                    <table className="min-w-full bg-white border">
                      <thead>
                        <tr>
                          {dataImport.headers.map((header, i) => (
                            <th
                              key={i}
                              className="py-2 px-3 border bg-gray-200"
                            >
                              {header}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {dataImport.formatted.map((row, rowIndex) => (
                          <tr className="hover:bg-gray-200" key={rowIndex}>
                            {dataImport.headers.map((header, i) => (
                              <td key={i} className="py-2 px-3 border">
                                {row[header]?.toString() || ""}
                              </td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : null}

                  <div className="flex gap-2 justify-end w-full">
                    <button
                      type="button"
                      className="flex gap-2 font-[500] items-center rounded-lg text-lg border-none p-2 bg-[#e74c3c] text-white transition cursor-pointer hover:bg-[#c0392b] font-Roboto"
                      onClick={() => {
                        closeModal();
                      }}
                    >
                      Cancelar
                    </button>
                  </div>
                </div>
              )
            ) : modalType === "delete" ? (
              <div className="flex flex-col justify-center items-center box-border p-4 gap-8 w-full">
                <h1 className="font-Oswald text-center">Excluir produto</h1>
                <p>
                  Tem certeza que deseja excluir o produto{" "}
                  <span className="font-bold">
                    {modalData.CODIGO}
                    {" - "}
                    {modalData.DESCRICAO}
                  </span>
                  ?
                </p>
                <div className="flex gap-2 justify-end w-full">
                  <button
                    onClick={() => {
                      closeModal();
                    }}
                    className="flex gap-2 font-[500] items-center rounded-lg text-lg border-none p-2 bg-[#2185D0] text-white transition cursor-pointer hover:bg-[#1A6DA8] font-Roboto"
                  >
                    Cancelar
                  </button>
                  <button
                    type="submit"
                    onClick={(e) => {
                      handleSubmit(e);
                    }}
                    className="flex gap-2 font-[500] items-center rounded-lg text-lg border-none p-2 bg-[#e74c3c] text-white transition cursor-pointer hover:bg-[#c0392b] font-Roboto"
                  >
                    Excluir
                  </button>
                </div>
              </div>
            ) : (
              <div className="flex box-border p-4 flex-col gap-2 w-full">
                <DashboardProduto codProd={modalData.CODIGO} />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
